import React from 'react';

import Checkbox from '../Checkbox';
import SubFields from '../SubFields';

export default function NestedField({ field, formik }) {
  return (
    <div key={field.name}>
      <div className="py-3">
        <Checkbox field={field} formik={formik} />
        {field.subFields && formik.values[field.name] && (
          <SubFields subFields={field.subFields} formik={formik} />
        )}
      </div>
      <hr />
    </div>
  );
}
